// Do not add data types here this will break infering on the reducer switch
// we use typeof instead
// Types
export const ADD_REDPOINTS_BALANCE_SUCCESS = 'ADD_REDPOINTS_BALANCE_SUCCESS'
export const ADD_REDPOINTS_REQUEST = 'ADD_REDPOINTS_REQUEST'
export const ADD_REDPOINTS_SUCCESS = 'ADD_REDPOINTS_SUCCESS'
export const ADD_VOUCHER_REQUEST = 'ADD_VOUCHER_REQUEST'
export const ADD_VOUCHER_SUCCESS = 'ADD_VOUCHER_SUCCESS'
export const CART_ERROR = 'CART_ERROR'
export const CHANGE_SELECTED_REDPOINTS_SUCCESS_ACTION =
  'CHANGE_SELECTED_REDPOINTS_SUCCESS_ACTION'
export const DELETE_CART_ITEM_REQUEST = 'DELETE_CART_ITEM_REQUEST'
export const DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS'
export const DELETE_REDPOINTS_SUCCESS = 'DELETE_REDPOINTS_SUCCESS'
export const DELETE_VOUCHER_SUCCESS = 'DELETE_VOUCHER_SUCCESS'
export const RESET_VOUCHER_SUCCESS = 'RESET_VOUCHER_SUCCESS'
export const SET_COLLECTIVE_ORDER = 'SET_COLLECTIVE_ORDER'
export const UPDATE_CART_REQUEST = 'UPDATE_CARTPAGE_REQUEST'
export const UPDATE_CART_SUCCESS = 'UPDATE_CARTPAGE_SUCCESS'
export const CHANGE_CURRENT_REDPOINTS_ACTION = 'CHANGE_CURRENT_REDPOINTS_ACTION'
export const CHANGE_PRESCRIPTION_FOLLOWS_SUCCESS =
  'CHANGE_PRESCRIPTION_FOLLOWS_SUCCESS'
